import React from "react";
import { NavLink } from "react-router-dom";

type Props = {
    variant: "desktop" | "mobile";
    onNavigate?: () => void;
};

const makeClass =
    (base: string, active: string) =>
        ({ isActive }: { isActive: boolean }) =>
            base + (isActive ? ` ${active}` : "");

export const NavLinks: React.FC<Props> = ({ variant, onNavigate }) => {
    const isDesktop = variant === "desktop";

    const linkClass = isDesktop
        ? makeClass("nav-link", "nav-link--active")
        : makeClass("mobile-menu-link", "mobile-menu-link--active");

    return (
        <>
            <NavLink to="/" end className={linkClass} onClick={onNavigate}>
                О нас
            </NavLink>

            <NavLink to="/calculator" className={linkClass} onClick={onNavigate}>
                Калькулятор
            </NavLink>

            <NavLink to="/news" className={linkClass} onClick={onNavigate}>
                Новости
            </NavLink>

            <NavLink to="/schedule" className={linkClass} onClick={onNavigate}>
                Расписание поставок
            </NavLink>
        </>
    );
};
